var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
	'form-group',
	{'is-small': _vm.small},
	{'is-compact': _vm.compact},
	{'has-error' : _vm.hasError}
]},[_c('label',{staticClass:"label",attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]),_c('input',{class:_vm.inputClasses,attrs:{"type":_vm.type,"name":_vm.name},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('FormError',{attrs:{"error":_vm.hasError,"message":_vm.errorMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }